import SearchIcon from '@mui/icons-material/Search';
import { IconButton, ListItemIcon, ListItemText, MenuItem, Theme, Tooltip } from '@mui/material';
import { useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { QuickCallPopover } from './QuickCallPopover';

interface Props {
    isCompOnMenu: boolean;
}
export function NavQuickCall({ isCompOnMenu = false }: Props) {
    const { classes } = useStyles();

    //popOver functionality
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    if (isCompOnMenu) {
        return (
            <>
                <MenuItem onClick={handleClick}>
                    <ListItemIcon>
                        <SearchIcon />
                    </ListItemIcon>
                    <ListItemText primary="Search" />
                </MenuItem>
                <QuickCallPopover anchorEl={anchorEl} handleClose={handleClose} />
            </>
        );
    }

    return (
        <>
            <Tooltip title="Search Contact and Quick Call">
                <IconButton onClick={handleClick} size="large" className={classes.iconButton}>
                    <SearchIcon />
                </IconButton>
            </Tooltip>
            <QuickCallPopover anchorEl={anchorEl} handleClose={handleClose} />
        </>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    iconButton: {
        padding: theme.spacing(1),
        '& .MuiSvgIcon-root': {
            fill: theme.palette.appHeader.contrastText,
        },
    },
}));
